import DashboardItem, { proseClasses } from './dashboard-item';
import { hash } from '@ember/helper';
import { HStack, VStack } from 'tio-reimagined/components/layout';
import { LinkTo } from '@ember/routing';
import { getRecommendationCtaRoute } from 'tio-employee/utils/wellness-insights';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import { htmlSafe } from '@ember/template';
import matchMedia from 'tio-common/helpers/match-media';

/**
 * NB: original ask was for this component to be able to conditionally link
 * directly to a specific quesdtionnaire result view in the case that the
 * component definition arg specifies that this is a transitional component;
 * in that case, something would need to ensure that at least the id of the
 * corresponding recommndation model is available before rendering a non-
 * disabled link, and provide the recommendation id as the link's @model arg,
 * accessible via the WellnessInsightsComponentDefinition model's
 * getRecommendation method called with requestingApp string argument
 *
 * as for where to fetch the recommendations, that could happen in the route
 * model, on the instance method itself, or conditionally in the constructor
 * of this component. none of these ideas sound good to me - james 20250814
 */
export default class Recommendation extends DashboardItem {
  @service declare router: RouterService;

  get recommendationLinkIsRegistered() {
    try {
      return !!this.router.urlFor(getRecommendationCtaRoute(this.args.componentDefinition).to);
    } catch {
      return false;
    }
  }

  get ctaLinkRoute(): string {
    return getRecommendationCtaRoute(this.args.componentDefinition).to;
  }

  get ctaLinkQuery(): Record<string, unknown> {
    return getRecommendationCtaRoute(this.args.componentDefinition).query || {};
  }

  <template>
    {{#if (matchMedia "(min-width: 1024px)")}}
      <HStack class="items-center gap-6">
        <div class="basis-5/8 {{proseClasses}}">
          <h3 class="font-semibold">{{@componentDefinition.subtitle}}</h3>
          <div class="mt-2">
            <p>{{htmlSafe @componentDefinition.text}}</p>
          </div>
        </div>
        <div class="flex justify-end w-auto">
          {{#if this.recommendationLinkIsRegistered}}
            <LinkTo
              @route={{this.ctaLinkRoute}}
              @query={{this.ctaLinkQuery}}
              class="tio-btn tio-btn--primary tio-btn--md block w-64 text-center"
            >
              {{this.translate "recommendation.button_text" (hash type=@componentDefinition.type)}}
            </LinkTo>
          {{else}}
            <a
              href={{this.ctaLinkRoute}}
              class="tio-btn tio-btn--primary tio-btn--md block w-64 text-center"
            >
              {{this.translate "recommendation.button_text" (hash type=@componentDefinition.type)}}
            </a>
          {{/if}}
        </div>
      </HStack>
    {{else}}
      <VStack class="gap-4">
        <div class="{{proseClasses}}">
          <h3 class="font-semibold">{{@componentDefinition.subtitle}}</h3>
          <div class="mt-2">
            <p>{{htmlSafe @componentDefinition.text}}</p>
          </div>
        </div>
        <div class="flex justify-center">
          {{#if this.recommendationLinkIsRegistered}}
            <LinkTo
              @route={{this.ctaLinkRoute}}
              @query={{this.ctaLinkQuery}}
              class="tio-btn tio-btn--primary tio-btn--md block text-center"
            >
              {{this.translate "recommendation.button_text" (hash type=@componentDefinition.type)}}
            </LinkTo>
          {{else}}
            <a
              href={{this.ctaLinkRoute}}
              class="tio-btn tio-btn--primary tio-btn--md block w-full text-center"
            >
              {{this.translate "recommendation.button_text" (hash type=@componentDefinition.type)}}
            </a>
          {{/if}}
        </div>
      </VStack>
    {{/if}}
  </template>
}
